<div id="form-container">
  <form
    [formGroup]="form"
    id="main-form"
    data-testid="main-form"
    class="col col-m-7 col-l-8 col-xl-8 col-xxl-7 lpb-8"
    (ngSubmit)="onSubmit()">
    <h3 class="ui-heading-3-bold">
      @if(customMilestone().ccmID == undefined){
        Create
      }
      Milestone
    </h3>

    <app-expandable-input label="Title" [control]="form.controls.title" [data-testid]="'title'"></app-expandable-input>

    <rds-form-field labelPosition="side-left">
      <rds-control-label>Date</rds-control-label>
      <input rdsInput formControlName="date" [rdsDatepicker]="picker" (focus)="picker.open()" data-testid="date"/>
      <rds-datepicker-toggle rds-control-suffix/>
      <rds-datepicker #picker showToggle="true"></rds-datepicker>
    </rds-form-field>
    <rds-divider></rds-divider>
    <div id="editable">
      <div id="custom-data">
        <div class="rds-form-field">
          <section class="list">
            <p class="rds-form-field__label list-label">Keywords</p>
            <div class="list-content">
              @for(keyword of form.controls.keyWords.controls; track keyword){
                <rds-form-field labelPosition="side-left">
                  <input rdsInput [formControl]="keyword" data-testid="keywords" (keypress)="onKeywordKeypress($event)"/>
                  <div class="d-flex align-items-center justify-content-end" [style.visibility]="editorActionsVisible">
                    <button rds-control-suffix rds-icon-button (click)="removeKeyword($index)"
                            size="s" class="ms-2" data-testid="keyword-remove">
                      <rds-icon namespace="outlined" icon="close"/>
                    </button>
                  </div>
                </rds-form-field>
              }
            </div>
          </section>
          <button rds-text-button (click)="addKeyword()" class="ms-auto" type="button" data-testid="keyword-add" [style.visibility]="editorActionsVisible">
            <rds-icon namespace="filled" icon="plus"/>
            Add Keyword
          </button>
        </div>
        <rds-form-field labelPosition="side-left">
          <rds-control-label>Link</rds-control-label>
          <input
            rdsInput
            formControlName="link"
            placeholder="Link"
            data-testid="link"
          />
          @if(form.controls.link.value) {
            <div class="d-flex align-items-center justify-content-end">
              <button rds-icon-button size="m" class="ms-2" type="button">
                <rds-icon namespace="filled" icon="link" (click)="openLink()"></rds-icon>
              </button>
            </div>
          }
        </rds-form-field>
        <app-expandable-input label="Notes" [control]="form.controls.notes" [data-testid]="'notes'"></app-expandable-input>
        
        <!-- Strategic Pillar Selector -->
        @if(customMilestone().abstractID) {
          <app-strategic-pillar-selector
            entityType="custom_milestone"
            [entityId]="customMilestone().abstractID!"
            [isViewer]="isViewer"
            (pillarChanged)="onPillarChanged($event)">
          </app-strategic-pillar-selector>
            <!-- Audience Selector -->
            <app-audience-selector
              [entityType]="'custom_milestone'"
              [entityId]="customMilestone().abstractID!"
              [isViewer]="isViewer">
            </app-audience-selector>
        }
      </div>
      @if(!isViewer){
        <rds-divider></rds-divider>
        <div id="editable">
            <rds-switch formControlName="isVisible" labelPosition="before" [checked]="form.controls.isVisible">Visible for viewers?</rds-switch>
        </div>
    }
    </div>
    <div id="controls">
      @if(customMilestone().ccmID){
        <button rds-secondary-warning-button type="button" [disabled]="isLoadingChanges()" (click)="onDelete()" [style.visibility]="editorActionsVisible">Delete</button>
      }
      <button rds-primary-button class="ms-auto" type="submit" [disabled]="isLoadingChanges()" size="m" data-testid="submit" [style.visibility]="editorActionsVisible">
        @if(!isLoadingChanges()){
          Save
        }
        @else{
          <rds-progress-spinner label="Updating..." size="m" ></rds-progress-spinner>
        }
      </button>
    </div>
  </form>
</div>
